<template>
  <sidebar-item
    class="text-white"
    :key="2"
    :menu="true"
    :link="{
      name: d.$t('Settings'),
      icon: 'circle',
    }"
  >
    <sidebar-item
      v-if="d.hasPermission('settings_manage')"
      class="text-white"
      :key="'2-1'"
      :link="{
        name: d.$t('System Configuration') || 'System Configuration',
        icon: 'cog',
        path: `/settings`,
      }"
    />
    <sidebar-item
      class="text-white"
      :key="'user-menu-editor'"
      :link="{
        name: d.$t('userMenu.title'),
        icon: 'bars',
        path: `/gotrading/user-menu`,
      }"
    />
    <sidebar-item
      v-if="d.hasPermission('model-definitions.view')"
      class="text-white"
      :key="8"
      :link="{
        name: 'Model Mapping',
        icon: 'retweet',
        path: `/gotrading/model-reference-mapping`,
      }"
    />
    <sidebar-item
      v-if="d.hasPermission('model-definitions.view')"
      class="text-white"
      :key="22"
      :link="{
        name: 'Model Definitions',
        icon: 'sitemap',
        path: `/model-definitions`,
      }"
    />
    <sidebar-item
      v-if="d.isAdminRole"
      class="text-white"
      :key="'hook-automations'"
      :link="{
        name: 'Hook automations',
        icon: 'bolt',
        path: `/hook-automations`,
      }"
    />
    <sidebar-item
      v-if="d.hasPermission('views.view')"
      class="text-white"
      :key="3"
      :link="{
        name: 'Views',
        icon: 'eye',
        path: `/views`,
      }"
    />
    <sidebar-item
      v-if="d.hasPermission('roles.view')"
      class="text-white"
      :key="4"
      :link="{
        name: 'Roles',
        icon: 'user',
        path: `/roles`,
      }"
    />
    <sidebar-item
      v-if="d.canAccessUsersSettings()"
      class="text-white"
      :key="5"
      :link="{
        name: d.$t('Users'),
        icon: 'users',
        path: `/users`,
      }"
    />
    <sidebar-item
      v-if="d.hasPermission('lists.view')"
      class="text-white"
      :key="6"
      :link="{
        name: d.$t('Lists'),
        icon: 'list',
        path: `/lists`,
      }"
    />
    <sidebar-item
      v-if="d.hasPermission('views.view')"
      class="text-white"
      :key="63"
      :link="{
        name: 'Links',
        icon: 'link',
        path: `/gotrading/admin-links`,
      }"
    />
    <sidebar-item
      v-if="d.hasPermission('settings_manage') && d.isAdminRole"
      class="text-white"
      :key="25"
      :link="{
        name: 'Módulos del Sistema',
        icon: 'box',
        path: `/modules`,
      }"
    />
    <sidebar-item
      v-if="d.hasPermission('settings_manage')"
      class="text-white"
      :key="24"
      :link="{
        name: 'Relaciones',
        icon: 'link',
        path: `/relationships`,
      }"
    />
    <sidebar-item
      v-if="d.hasPermission('settings_manage')"
      class="text-white"
      :key="23"
      :link="{
        name: 'Prompts IA',
        icon: 'robot',
        path: `/gotrading/prompt-settings`,
      }"
    />
    <sidebar-item
      v-if="d.isAdminRole"
      class="text-white"
      :key="26"
      :link="{
        name: d.$t('Orphans') || 'Orphans',
        icon: 'unlink',
        path: `/settings/orphans`,
      }"
    />
    <sidebar-item
      v-if="d.isAdminRole"
      class="text-white"
      :key="27"
      :link="{
        name: d.$t('refIntegrityAdmin.menu'),
        icon: 'database',
        path: `/admin/ref-integrity`,
      }"
    />
    <sidebar-item
      v-if="d.isAdminRole"
      class="text-white"
      :key="28"
      :link="{
        name: d.$t('migrations.menu'),
        icon: 'code-branch',
        path: `/settings/migrations`,
      }"
    />
  </sidebar-item>
</template>

<script>
export default {
  name: "DashboardSidebarSettingsBlock",
  inject: ["dashboardLayout"],
  computed: {
    d() {
      return this.dashboardLayout;
    },
  },
};
</script>
